export default __webpack_public_path__ + "static/media/PathModal.8a84860a.svg";